"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CardFooter_1 = __importDefault(require("./CardFooter"));
exports.default = CardFooter_1.default;
